export default "__VITE_ASSET__BpgmEGcx__"